import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import { toastSuccess, toastError, toastInfo } from "../../utils/alertHelper";

function Otp() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    const email = localStorage.getItem("email");
    try {
      const response = await axios.post("/api/user/verifyOtp", {
       email,
       otp
      });
      const { Status, UserToken, user, defaultCountry, defaultState, defaultCity } = response.data;
      
            if (Status === 1) {
              const role = user.roles?.[0]?.name || "";
      
              localStorage.setItem("email", user.email);
              localStorage.setItem("role", role);
              localStorage.setItem("token", UserToken);
              localStorage.setItem("defaultCountry", defaultCountry?._id || "");
              localStorage.setItem("defaultState", defaultState?._id || "");
              localStorage.setItem("defaultCity", defaultCity?._id || "");
              localStorage.setItem("auth", "true");
      
              toastSuccess("Login successful");
              navigate("/dashboard");
            } else {
              toastError("Wrong OTP");
            }
          } catch (error) {
            console.error(error);
            toastError("Something went wrong, please try again");
          }
        };
      

  return (
    <div className="">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-center min-vh-100">
                        <div className="w-50 d-block bg-white shadow-lg rounded my-5">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="p-5">
                                        <h1 className="h5 mb-1 text-center">Welcome Back!</h1>
                                        <p className="text-muted mb-4">Enter your email address and password to access admin panel.</p>
                                        <form onSubmit={handleVerify}>
                                            <div className="form-group">
                                                <input
                                                      type="text"
                                                      placeholder="Enter OTP"
                                                      onChange={(e) => setOtp(e.target.value)}
                                                      className="form-control form-control-user"
                                                      id="exampleInputEmail"
                                                      required
                                                    />
                                            </div>
                                            <button type="submit" className="btn btn-success btn-block waves-effect waves-light">Verify OTP</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Otp;
